import pick from "lodash/pick";

import { Address, Contact, CountryWeSellTo, Region } from "../types";

import { removeNilProperties } from "./helpers";

export const convertContactToAddress = (contact: Contact): Address => {
  return pick(removeNilProperties(contact) as Contact, [
    "firstName",
    "lastName",
    "address1",
    "address2",
    "city",
    "state",
    "postalCode",
    "country",
  ]);
};

export const convertAddressToContact = (
  address: Address,
  personalEmail: string,
) => {
  const shipToContact: Contact = {
    ...address,
    personalEmail,
  };
  return shipToContact;
};

export const convertStateTo2CharStateCode = (
  stateName: string | undefined,
  country: CountryWeSellTo | undefined,
): string | undefined => {
  const state = country?.regions.find(
    (region: Region) => region.label === stateName,
  );
  return state?.value ?? stateName;
};

export const convertAddressStateNameTo2CharCode = (
  addressData: Address,
  countries: CountryWeSellTo[],
): Address => {
  return {
    ...addressData,
    state: convertStateTo2CharStateCode(
      addressData.state,
      countries.find((c) => c.countryCode === addressData.country),
    ),
  };
};
